// Captain / ship / voyage art. PNG when available (generated under
// public/art/<cat>/<id>.png), inline-SVG silhouette as fallback for
// any id without a PNG yet.
import { captainImgUrl, shipImgUrl, voyageImgUrl } from './art-png';
export function captainArt(id) {
    const url = captainImgUrl(id);
    if (url)
        return `<img class="art-img art-img--captain" src="${url}" alt="" loading="lazy" />`;
    return captainArtSvg(id);
}
export function shipArt(id) {
    const url = shipImgUrl(id);
    if (url)
        return `<img class="art-img art-img--ship" src="${url}" alt="" loading="lazy" />`;
    return shipArtSvg(id);
}
export function voyageIcon(id) {
    const url = voyageImgUrl(id);
    if (url)
        return `<img class="art-img art-img--voyage" src="${url}" alt="" loading="lazy" />`;
    return voyageIconSvg(id);
}
function captainArtSvg(id) {
    const common = `viewBox="0 0 100 120" preserveAspectRatio="xMidYMid meet"`;
    switch (id) {
        case 'iron':
            return `<svg ${common}>
        <defs><linearGradient id="iron-grad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stop-color="#b8c0c8"/><stop offset="1" stop-color="#3a4452"/>
        </linearGradient></defs>
        <!-- Tricorn -->
        <path d="M22 30 Q50 12 78 30 L72 38 Q50 30 28 38 Z" fill="#1a1410" />
        <path d="M30 30 Q50 22 70 30 L66 28 Q50 22 34 28 Z" fill="#a83232" />
        <!-- Head -->
        <ellipse cx="50" cy="45" rx="13" ry="14" fill="#d6b893" />
        <!-- Eyepatch -->
        <path d="M44 42 L58 42 L57 47 L43 47 Z" fill="#1a1410" />
        <line x1="40" y1="44" x2="62" y2="42" stroke="#1a1410" stroke-width="1.5"/>
        <!-- Beard -->
        <path d="M40 52 Q50 64 60 52 L60 58 Q50 70 40 58 Z" fill="#3a2418" />
        <!-- Body / armor -->
        <path d="M30 65 L70 65 L74 110 L26 110 Z" fill="url(#iron-grad)" stroke="#1a1410" stroke-width="2" />
        <!-- Bandolier -->
        <line x1="32" y1="68" x2="68" y2="106" stroke="#5a3a1f" stroke-width="3" />
        <circle cx="42" cy="80" r="2.5" fill="#c69b3c" />
        <circle cx="50" cy="90" r="2.5" fill="#c69b3c" />
        <circle cx="58" cy="100" r="2.5" fill="#c69b3c" />
      </svg>`;
        case 'doubloon':
            return `<svg ${common}>
        <defs><linearGradient id="dub-grad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stop-color="#f0c75a"/><stop offset="1" stop-color="#7a5418"/>
        </linearGradient></defs>
        <!-- Plume hat -->
        <path d="M20 35 Q50 5 80 35 L72 40 Q50 28 28 40 Z" fill="#3a2418" />
        <path d="M50 8 Q60 0 70 14 Q60 18 56 22 Z" fill="#c69b3c" />
        <!-- Head -->
        <ellipse cx="50" cy="48" rx="12" ry="13" fill="#e6cca0" />
        <!-- Mustache -->
        <path d="M42 54 Q50 60 58 54 L56 58 Q50 56 44 58 Z" fill="#3a2418" />
        <!-- Coat -->
        <path d="M30 64 L70 64 L78 110 L22 110 Z" fill="url(#dub-grad)" stroke="#1a1410" stroke-width="2"/>
        <!-- Lapel + buttons -->
        <line x1="50" y1="64" x2="50" y2="108" stroke="#1a1410" stroke-width="1.2" />
        <circle cx="50" cy="74" r="2" fill="#f0c75a" />
        <circle cx="50" cy="86" r="2" fill="#f0c75a" />
        <circle cx="50" cy="98" r="2" fill="#f0c75a" />
        <!-- Coin charms -->
        <circle cx="38" cy="76" r="3" fill="#f0c75a" stroke="#1a1410" stroke-width="0.6"/>
        <circle cx="62" cy="92" r="3" fill="#f0c75a" stroke="#1a1410" stroke-width="0.6"/>
      </svg>`;
        case 'tide':
            return `<svg ${common}>
        <defs><linearGradient id="tide-grad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stop-color="#3a8a8e"/><stop offset="1" stop-color="#0e2933"/>
        </linearGradient></defs>
        <!-- Hood -->
        <path d="M20 50 Q22 22 50 18 Q78 22 80 50 L75 60 Q50 50 25 60 Z" fill="#1a3a44" />
        <!-- Head shadow -->
        <ellipse cx="50" cy="48" rx="11" ry="12" fill="#3a4f5a" />
        <!-- Glowing eyes -->
        <ellipse cx="45" cy="48" rx="1.5" ry="2" fill="#7adff5" />
        <ellipse cx="55" cy="48" rx="1.5" ry="2" fill="#7adff5" />
        <!-- Cloak -->
        <path d="M22 60 Q28 70 22 80 Q30 90 22 110 L78 110 Q70 90 78 80 Q72 70 78 60 Q50 70 22 60 Z" fill="url(#tide-grad)" stroke="#0a1a22" stroke-width="2"/>
        <!-- Coral medallion -->
        <circle cx="50" cy="80" r="5" fill="#7adff5" opacity="0.6" />
        <circle cx="50" cy="80" r="3" fill="#a8e7f0" />
      </svg>`;
        case 'squall':
            return `<svg ${common}>
        <defs><linearGradient id="squall-grad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stop-color="#34546a"/><stop offset="1" stop-color="#16242f"/>
        </linearGradient></defs>
        <!-- Bicorne hat -->
        <path d="M18 38 Q50 14 82 38 Q72 44 50 42 Q28 44 18 38 Z" fill="#1c2a36" stroke="#0c141c" stroke-width="1.5" />
        <!-- Hat trim -->
        <path d="M22 38 Q50 30 78 38" stroke="#c9b27a" stroke-width="1.2" fill="none" />
        <!-- Head -->
        <ellipse cx="50" cy="52" rx="11" ry="12" fill="#d6b89a" />
        <!-- Eyes (calm, narrow) -->
        <ellipse cx="45" cy="50" rx="1.3" ry="1.1" fill="#0c141c" />
        <ellipse cx="55" cy="50" rx="1.3" ry="1.1" fill="#0c141c" />
        <!-- Mouth, set line -->
        <path d="M44 58 Q50 60 56 58" stroke="#5a3a28" stroke-width="1.1" fill="none" />
        <!-- Storm-grey coat -->
        <path d="M22 65 L78 65 L80 110 L20 110 Z" fill="url(#squall-grad)" stroke="#0c141c" stroke-width="2" />
        <!-- Coat lapels -->
        <path d="M50 65 L40 76 L50 82 L60 76 Z" fill="#22384a" stroke="#0c141c" stroke-width="1" />
        <!-- Lightning-bolt pin -->
        <path d="M48 86 L52 86 L49 92 L53 92 L47 102 L50 94 L46 94 Z" fill="#f4d77a" stroke="#a07b1a" stroke-width="0.6" />
      </svg>`;
        case 'salt':
            return `<svg ${common}>
        <defs><linearGradient id="salt-grad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stop-color="#5a4a38"/><stop offset="1" stop-color="#1a1410"/>
        </linearGradient></defs>
        <!-- Knit cap -->
        <path d="M28 36 Q50 20 72 36 L72 42 L28 42 Z" fill="#3a2418" />
        <ellipse cx="50" cy="22" rx="3" ry="3" fill="#3a2418"/>
        <!-- Head, weathered -->
        <ellipse cx="50" cy="48" rx="12" ry="13" fill="#cba888" />
        <!-- White beard -->
        <path d="M36 54 Q50 76 64 54 L64 64 Q50 80 36 64 Z" fill="#e8e0d0" />
        <!-- Pipe -->
        <line x1="58" y1="60" x2="68" y2="64" stroke="#3a2418" stroke-width="2"/>
        <circle cx="68" cy="64" r="2" fill="#7a4818" />
        <circle cx="69" cy="60" r="1" fill="#f0c75a" opacity="0.7" />
        <!-- Worn coat -->
        <path d="M28 66 L72 66 L76 110 L24 110 Z" fill="url(#salt-grad)" stroke="#1a1410" stroke-width="2"/>
        <!-- Patch -->
        <rect x="40" y="84" width="8" height="6" fill="#7a5a38" stroke="#1a1410" stroke-width="0.6"/>
      </svg>`;
        case 'stormbringer':
            // Iron-style silhouette tinted storm-blue
            return `<svg ${common}>
        <defs><linearGradient id="storm-grad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stop-color="#5a78a0"/><stop offset="1" stop-color="#1a2a44"/>
        </linearGradient></defs>
        <path d="M22 30 Q50 12 78 30 L72 38 Q50 30 28 38 Z" fill="#0a121f" />
        <path d="M30 30 Q50 22 70 30 L66 28 Q50 22 34 28 Z" fill="#7a99c2" />
        <ellipse cx="50" cy="45" rx="13" ry="14" fill="#cfd9e6" />
        <path d="M40 52 Q50 64 60 52 L60 58 Q50 70 40 58 Z" fill="#1a2433" />
        <!-- Lightning bolt -->
        <path d="M60 22 L52 38 L58 38 L48 56 L62 36 L56 36 Z" fill="#e6c853" opacity="0.85"/>
        <path d="M30 65 L70 65 L74 110 L26 110 Z" fill="url(#storm-grad)" stroke="#0a121f" stroke-width="2" />
      </svg>`;
        case 'crimson':
            return `<svg ${common}>
        <defs><linearGradient id="crim-grad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stop-color="#c83838"/><stop offset="1" stop-color="#5a0e0e"/>
        </linearGradient></defs>
        <path d="M22 30 Q50 12 78 30 L72 38 Q50 30 28 38 Z" fill="#1a0608" />
        <path d="M30 30 Q50 22 70 30 L66 28 Q50 22 34 28 Z" fill="#c83838" />
        <ellipse cx="50" cy="45" rx="13" ry="14" fill="#d6a888" />
        <path d="M44 42 L58 42 L57 47 L43 47 Z" fill="#1a0608" />
        <path d="M40 52 Q50 64 60 52 L60 58 Q50 70 40 58 Z" fill="#5a1a1a" />
        <path d="M30 65 L70 65 L74 110 L26 110 Z" fill="url(#crim-grad)" stroke="#1a0608" stroke-width="2"/>
        <line x1="32" y1="68" x2="68" y2="106" stroke="#1a0608" stroke-width="3" />
      </svg>`;
        case 'ember':
            return `<svg ${common}>
        <defs><linearGradient id="ember-grad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stop-color="#d8722a"/><stop offset="1" stop-color="#3a1a0a"/>
        </linearGradient></defs>
        <path d="M28 36 Q50 20 72 36 L72 42 L28 42 Z" fill="#1a0a05" />
        <ellipse cx="50" cy="48" rx="12" ry="13" fill="#d8a080" />
        <path d="M36 54 Q50 76 64 54 L64 64 Q50 80 36 64 Z" fill="#888070" />
        <!-- Glowing pipe ember -->
        <line x1="58" y1="60" x2="68" y2="64" stroke="#3a1808" stroke-width="2"/>
        <circle cx="69" cy="62" r="3" fill="#f0c75a" opacity="0.95" />
        <circle cx="69" cy="62" r="6" fill="#f0c75a" opacity="0.25" />
        <path d="M28 66 L72 66 L76 110 L24 110 Z" fill="url(#ember-grad)" stroke="#1a0a05" stroke-width="2"/>
      </svg>`;
        case 'wraith':
            return `<svg ${common}>
        <defs><linearGradient id="wraith-grad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stop-color="#8a98a8"/><stop offset="1" stop-color="#1a2228"/>
        </linearGradient></defs>
        <path d="M14 60 Q14 18 50 14 Q86 18 86 60 L78 70 Q50 60 22 70 Z" fill="#1a2228" opacity="0.85" />
        <ellipse cx="50" cy="50" rx="10" ry="11" fill="#2a3038" />
        <ellipse cx="46" cy="50" rx="2" ry="2.5" fill="#cfe6f0" />
        <ellipse cx="54" cy="50" rx="2" ry="2.5" fill="#cfe6f0" />
        <path d="M16 64 Q22 76 16 86 Q26 96 18 110 L82 110 Q74 96 84 86 Q78 76 84 64 Q50 76 16 64 Z" fill="url(#wraith-grad)" opacity="0.85" stroke="#0a141a" stroke-width="1.5"/>
      </svg>`;
        default:
            return `<svg ${common}><circle cx="50" cy="60" r="32" fill="#3a4f5a"/></svg>`;
    }
}
function shipArtSvg(id) {
    const common = `viewBox="0 0 140 90" preserveAspectRatio="xMidYMid meet"`;
    switch (id) {
        case 'sloop':
            return `<svg ${common}>
        <!-- Hull -->
        <path d="M22 60 L118 60 L108 78 L32 78 Z" fill="#3a2418" stroke="#1a0a05" stroke-width="1.5"/>
        <!-- Single mast -->
        <line x1="70" y1="60" x2="70" y2="14" stroke="#1a0a05" stroke-width="2"/>
        <!-- Single sail -->
        <path d="M70 18 Q92 28 70 56 Z" fill="#e8d5a8" stroke="#1a0a05" stroke-width="1"/>
        <!-- Flag -->
        <path d="M70 12 L82 16 L70 20 Z" fill="#a83232"/>
        <!-- Waterline -->
        <path d="M22 76 Q40 80 70 76 Q100 80 118 76" stroke="#5a8090" stroke-width="2" fill="none"/>
      </svg>`;
        case 'brigantine':
            return `<svg ${common}>
        <!-- Hull, deeper -->
        <path d="M16 56 L124 56 L114 80 L26 80 Z" fill="#3a2418" stroke="#1a0a05" stroke-width="1.5"/>
        <line x1="20" y1="64" x2="120" y2="64" stroke="#5a3a18" stroke-width="1"/>
        <!-- Two masts -->
        <line x1="50" y1="56" x2="50" y2="10" stroke="#1a0a05" stroke-width="2"/>
        <line x1="90" y1="56" x2="90" y2="14" stroke="#1a0a05" stroke-width="2"/>
        <!-- Sails -->
        <rect x="38" y="18" width="24" height="14" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.8"/>
        <rect x="40" y="34" width="20" height="18" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.8"/>
        <rect x="78" y="22" width="24" height="14" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.8"/>
        <rect x="80" y="38" width="20" height="14" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.8"/>
        <!-- Flag -->
        <path d="M50 8 L62 12 L50 16 Z" fill="#a83232"/>
        <!-- Waterline -->
        <path d="M16 78 Q40 84 70 78 Q100 84 124 78" stroke="#5a8090" stroke-width="2" fill="none"/>
      </svg>`;
        case 'galleon':
            return `<svg ${common}>
        <!-- Massive hull -->
        <path d="M10 48 L130 48 L120 82 L20 82 Z" fill="#3a2418" stroke="#1a0a05" stroke-width="1.5"/>
        <line x1="14" y1="58" x2="126" y2="58" stroke="#5a3a18" stroke-width="1"/>
        <!-- Gun ports -->
        <rect x="25" y="64" width="4" height="3" fill="#1a0a05"/>
        <rect x="40" y="64" width="4" height="3" fill="#1a0a05"/>
        <rect x="55" y="64" width="4" height="3" fill="#1a0a05"/>
        <rect x="70" y="64" width="4" height="3" fill="#1a0a05"/>
        <rect x="85" y="64" width="4" height="3" fill="#1a0a05"/>
        <rect x="100" y="64" width="4" height="3" fill="#1a0a05"/>
        <rect x="115" y="64" width="4" height="3" fill="#1a0a05"/>
        <!-- Three masts -->
        <line x1="38" y1="48" x2="38" y2="14" stroke="#1a0a05" stroke-width="2.2"/>
        <line x1="70" y1="48" x2="70" y2="6" stroke="#1a0a05" stroke-width="2.2"/>
        <line x1="102" y1="48" x2="102" y2="14" stroke="#1a0a05" stroke-width="2.2"/>
        <!-- Sails -->
        <rect x="26" y="20" width="24" height="12" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <rect x="28" y="34" width="20" height="12" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <rect x="58" y="12" width="24" height="14" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <rect x="60" y="28" width="20" height="14" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <rect x="62" y="44" width="16" height="4" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <rect x="90" y="20" width="24" height="12" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <rect x="92" y="34" width="20" height="12" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <!-- Flag -->
        <path d="M70 4 L84 8 L70 12 Z" fill="#a83232"/>
        <!-- Waterline -->
        <path d="M10 80 Q40 86 70 80 Q100 86 130 80" stroke="#5a8090" stroke-width="2" fill="none"/>
      </svg>`;
        case 'cutter':
            return `<svg ${common}>
        <!-- Sleek hull -->
        <path d="M30 62 L110 62 L100 76 L40 76 Z" fill="#3a2418" stroke="#1a0a05" stroke-width="1.5"/>
        <!-- Single tall mast leaned -->
        <line x1="65" y1="62" x2="68" y2="6" stroke="#1a0a05" stroke-width="2"/>
        <!-- Triangular jib + main -->
        <path d="M68 8 Q90 30 68 58 Z" fill="#e8d5a8" stroke="#1a0a05" stroke-width="1"/>
        <path d="M68 18 Q42 38 65 58 Z" fill="#e8d5a8" stroke="#1a0a05" stroke-width="1"/>
        <path d="M68 6 L80 10 L68 14 Z" fill="#a83232"/>
        <path d="M30 74 Q60 80 110 74" stroke="#5a8090" stroke-width="2" fill="none"/>
      </svg>`;
        case 'phantom':
            return `<svg ${common}>
        <!-- Translucent hull -->
        <path d="M16 56 L124 56 L114 80 L26 80 Z" fill="#3a4f5a" opacity="0.65" stroke="#7adff5" stroke-width="1"/>
        <!-- Ghostly aura -->
        <ellipse cx="70" cy="68" rx="60" ry="22" fill="#7adff5" opacity="0.10"/>
        <line x1="50" y1="56" x2="50" y2="10" stroke="#5a7080" stroke-width="2" opacity="0.7"/>
        <line x1="90" y1="56" x2="90" y2="14" stroke="#5a7080" stroke-width="2" opacity="0.7"/>
        <rect x="38" y="18" width="24" height="14" fill="#a8c0d0" opacity="0.55" stroke="#7adff5" stroke-width="0.6"/>
        <rect x="40" y="34" width="20" height="18" fill="#a8c0d0" opacity="0.55" stroke="#7adff5" stroke-width="0.6"/>
        <rect x="78" y="22" width="24" height="14" fill="#a8c0d0" opacity="0.55" stroke="#7adff5" stroke-width="0.6"/>
        <rect x="80" y="38" width="20" height="14" fill="#a8c0d0" opacity="0.55" stroke="#7adff5" stroke-width="0.6"/>
        <!-- Skull flag -->
        <path d="M50 8 L62 12 L50 16 Z" fill="#1a0a14" opacity="0.7"/>
        <path d="M16 78 Q40 84 70 78 Q100 84 124 78" stroke="#7adff5" stroke-width="1.5" fill="none" opacity="0.7"/>
      </svg>`;
        case 'frigate':
            return `<svg ${common}>
        <path d="M14 56 L126 56 L116 80 L24 80 Z" fill="#3a2418" stroke="#1a0a05" stroke-width="1.5"/>
        <line x1="20" y1="64" x2="120" y2="64" stroke="#5a3a18" stroke-width="1"/>
        <rect x="35" y="62" width="3" height="3" fill="#1a0a05"/>
        <rect x="50" y="62" width="3" height="3" fill="#1a0a05"/>
        <rect x="65" y="62" width="3" height="3" fill="#1a0a05"/>
        <rect x="80" y="62" width="3" height="3" fill="#1a0a05"/>
        <rect x="95" y="62" width="3" height="3" fill="#1a0a05"/>
        <line x1="45" y1="56" x2="45" y2="8" stroke="#1a0a05" stroke-width="2"/>
        <line x1="95" y1="56" x2="95" y2="12" stroke="#1a0a05" stroke-width="2"/>
        <rect x="33" y="14" width="24" height="14" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.8"/>
        <rect x="35" y="30" width="20" height="18" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.8"/>
        <rect x="83" y="20" width="24" height="14" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.8"/>
        <rect x="85" y="36" width="20" height="14" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.8"/>
        <path d="M45 6 L57 10 L45 14 Z" fill="#a83232"/>
        <path d="M14 78 Q40 84 70 78 Q100 84 126 78" stroke="#5a8090" stroke-width="2" fill="none"/>
      </svg>`;
        case 'schooner':
            return `<svg ${common}>
        <path d="M22 60 L118 60 L106 78 L34 78 Z" fill="#3a2418" stroke="#1a0a05" stroke-width="1.5"/>
        <line x1="40" y1="60" x2="42" y2="6" stroke="#1a0a05" stroke-width="2"/>
        <line x1="90" y1="60" x2="90" y2="14" stroke="#1a0a05" stroke-width="2"/>
        <path d="M42 8 Q66 24 42 56 Z" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.8"/>
        <path d="M42 18 Q22 38 40 56 Z" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.8"/>
        <path d="M90 18 Q108 32 90 54 Z" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.8"/>
        <path d="M42 6 L54 10 L42 14 Z" fill="#a83232"/>
        <path d="M22 76 Q60 80 118 76" stroke="#5a8090" stroke-width="2" fill="none"/>
      </svg>`;
        case 'manowar':
            return `<svg ${common}>
        <path d="M6 46 L134 46 L122 84 L18 84 Z" fill="#2a1810" stroke="#1a0a05" stroke-width="1.5"/>
        <line x1="10" y1="58" x2="130" y2="58" stroke="#5a3a18" stroke-width="1"/>
        <line x1="10" y1="68" x2="130" y2="68" stroke="#5a3a18" stroke-width="1"/>
        ${[18, 30, 42, 54, 66, 78, 90, 102, 114, 122].map(x => `<rect x="${x}" y="60" width="4" height="3" fill="#1a0a05"/>`).join('')}
        ${[22, 34, 46, 58, 70, 82, 94, 106, 118].map(x => `<rect x="${x}" y="71" width="4" height="3" fill="#1a0a05"/>`).join('')}
        <line x1="32" y1="46" x2="32" y2="10" stroke="#1a0a05" stroke-width="2.4"/>
        <line x1="70" y1="46" x2="70" y2="2" stroke="#1a0a05" stroke-width="2.4"/>
        <line x1="108" y1="46" x2="108" y2="10" stroke="#1a0a05" stroke-width="2.4"/>
        <rect x="20" y="14" width="24" height="12" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <rect x="22" y="28" width="20" height="14" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <rect x="58" y="6" width="24" height="14" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <rect x="60" y="22" width="20" height="14" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <rect x="62" y="38" width="16" height="6" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <rect x="96" y="14" width="24" height="12" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <rect x="98" y="28" width="20" height="14" fill="#e8d5a8" stroke="#1a0a05" stroke-width="0.7"/>
        <path d="M70 0 L84 4 L70 8 Z" fill="#a83232"/>
        <path d="M6 82 Q40 88 70 82 Q100 88 134 82" stroke="#5a8090" stroke-width="2" fill="none"/>
      </svg>`;
        case 'leviathan':
            return `<svg ${common}>
        <path d="M4 50 L136 50 L122 84 L20 84 Z" fill="#1a0a14" stroke="#0a0508" stroke-width="1.5"/>
        <line x1="8" y1="62" x2="132" y2="62" stroke="#3a1818" stroke-width="1"/>
        <line x1="8" y1="72" x2="132" y2="72" stroke="#3a1818" stroke-width="1"/>
        ${Array.from({ length: 11 }, (_, i) => 14 + i * 11).map(x => `<rect x="${x}" y="64" width="4" height="3" fill="#0a0508"/>`).join('')}
        ${Array.from({ length: 11 }, (_, i) => 18 + i * 11).map(x => `<rect x="${x}" y="74" width="4" height="3" fill="#0a0508"/>`).join('')}
        <line x1="30" y1="50" x2="30" y2="6" stroke="#0a0508" stroke-width="2.6"/>
        <line x1="70" y1="50" x2="70" y2="0" stroke="#0a0508" stroke-width="2.6"/>
        <line x1="110" y1="50" x2="110" y2="6" stroke="#0a0508" stroke-width="2.6"/>
        <rect x="18" y="10" width="24" height="14" fill="#3a4f5a" stroke="#0a0508" stroke-width="0.7"/>
        <rect x="20" y="26" width="20" height="14" fill="#3a4f5a" stroke="#0a0508" stroke-width="0.7"/>
        <rect x="58" y="4" width="24" height="14" fill="#3a4f5a" stroke="#0a0508" stroke-width="0.7"/>
        <rect x="60" y="20" width="20" height="14" fill="#3a4f5a" stroke="#0a0508" stroke-width="0.7"/>
        <rect x="62" y="36" width="16" height="6" fill="#3a4f5a" stroke="#0a0508" stroke-width="0.7"/>
        <rect x="98" y="10" width="24" height="14" fill="#3a4f5a" stroke="#0a0508" stroke-width="0.7"/>
        <rect x="100" y="26" width="20" height="14" fill="#3a4f5a" stroke="#0a0508" stroke-width="0.7"/>
        <!-- Sea-monster figurehead -->
        <path d="M134 60 Q142 56 140 50 Q132 52 132 56 Z" fill="#7adff5" opacity="0.7"/>
        <path d="M70 -2 L88 2 L70 6 Z" fill="#a83232"/>
        <path d="M4 82 Q40 88 70 82 Q100 88 136 82" stroke="#7adff5" stroke-width="2" fill="none"/>
      </svg>`;
        default:
            return `<svg ${common}><rect x="20" y="50" width="100" height="20" fill="#3a2418"/></svg>`;
    }
}
function voyageIconSvg(id) {
    const common = `viewBox="0 0 60 60"`;
    switch (id) {
        case 'calm_seas':
            return `<svg ${common}><path d="M5 32 Q15 28 30 32 Q45 36 55 32" stroke="#7adff5" stroke-width="2" fill="none"/><path d="M5 42 Q15 38 30 42 Q45 46 55 42" stroke="#5a8090" stroke-width="2" fill="none"/><circle cx="46" cy="14" r="6" fill="#f0c75a"/></svg>`;
        case 'cursed_tides':
            return `<svg ${common}><path d="M5 30 Q15 14 30 30 Q45 46 55 30" stroke="#a83232" stroke-width="2.5" fill="none"/><path d="M5 44 Q15 28 30 44 Q45 60 55 44" stroke="#7a1818" stroke-width="2.5" fill="none"/></svg>`;
        case 'hoarders_curse':
            return `<svg ${common}><circle cx="30" cy="30" r="20" fill="#f0c75a" stroke="#7a5418" stroke-width="2"/><text x="30" y="38" text-anchor="middle" fill="#1a0a05" font-family="Georgia" font-weight="bold" font-size="20">$</text></svg>`;
        case 'one_shot':
            return `<svg ${common}><circle cx="30" cy="30" r="22" fill="none" stroke="#a83232" stroke-width="2"/><line x1="14" y1="14" x2="46" y2="46" stroke="#a83232" stroke-width="3"/><polygon points="42,30 30,22 30,38" fill="#a83232"/></svg>`;
        case 'no_mercy':
            return `<svg ${common}><path d="M20 18 L40 18 L40 14 L48 22 L40 30 L40 26 L20 26 L20 30 L12 22 L20 14 Z" fill="#a83232"/><path d="M14 40 L46 40" stroke="#a83232" stroke-width="3"/></svg>`;
        case 'endless_storm':
            return `<svg ${common}><path d="M14 14 Q24 6 34 14 Q46 22 36 30 Q24 22 14 30 Q6 22 14 14 Z" fill="#5a7090"/><path d="M28 28 L24 40 L30 40 L26 50 L34 36 L28 36 Z" fill="#f0c75a"/></svg>`;
        default:
            return `<svg ${common}><rect x="10" y="10" width="40" height="40" fill="#3a4f5a"/></svg>`;
    }
}
